import React from 'react';

import { CatalogInfoContainer } from 'src/components/containers';


const FloraCatalogInfoContainer = () => <CatalogInfoContainer apiType='flora' />;


export { FloraCatalogInfoContainer };
